import React from 'react';
import { Link } from 'react-router-dom';
import usePageMetadata from '../utils/usePageMetadata';
import './Guides.css';

const Guides = () => {
  usePageMetadata({
    title: 'Publisher Guides - The Ad Shop',
    description: 'Comprehensive guides to help publishers monetize and grow their websites. Learn about Google AdSense, ad optimization, and revenue strategies.',
    keywords: 'publisher guides, AdSense guide, monetization guide, ad optimization, publisher resources',
    canonicalUrl: 'https://theadshop.co/guides',
    meta: [
      { property: 'og:title', content: 'Publisher Guides - The Ad Shop' },
      { property: 'og:description', content: 'Learn how to monetize and grow your website with our comprehensive publisher guides.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://theadshop.co/guides' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: 'Publisher Guides - The Ad Shop' },
      { name: 'twitter:description', content: 'Comprehensive guides to help publishers monetize and grow their websites.' },
    ],
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: 'Publisher Guides',
      url: 'https://theadshop.co/guides',
      description: 'Comprehensive guides to help publishers monetize and grow their websites.',
      publisher: {
        '@type': 'Organization',
        name: 'The Media Shop, LLC',
        url: 'https://theadshop.co/',
      },
    },
  });

  const guides = [
    {
      id: 'adsense',
      title: 'Getting Started with Google AdSense',
      description: 'Complete guide to signing up for AdSense, getting your website approved, setting up your account, and optimization strategies.',
      link: '/guides/adsense',
      category: 'Monetization',
    },
  ];

  return (
    <div className="guides-page">
      <div className="guides-container">
        <header className="guides-header">
          <h1>Publisher Guides</h1>
          <p className="guides-intro">
            Comprehensive guides to help you monetize and grow your website. 
            Learn from industry experts and optimize your ad revenue.
          </p>
        </header>

        <div className="guides-grid">
          {guides.map((guide) => (
            <Link key={guide.id} to={guide.link} className="guide-card">
              <div className="guide-card-header">
                <span className="guide-category">{guide.category}</span>
              </div>
              <h2 className="guide-title">{guide.title}</h2>
              <p className="guide-description">{guide.description}</p>
              <div className="guide-link">
                Read Guide →
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Guides;

